import { createNonPersistentStore } from 'lib/zustand/store';

export type LoadingStoreState = {
  isLongLoadTimeExpected: boolean;
};

export const useLoadingStore = createNonPersistentStore<LoadingStoreState>(
  () => ({
    isLongLoadTimeExpected: false
  }),
  { isListeningScreenStore: true }
);

export const loadingStoreActions = {
  setIsLongLoadTimeExpected: (value: boolean) => useLoadingStore.setState({ isLongLoadTimeExpected: value })
};
